"use strict";

import Vue from "vue";
import axios from "axios";
import router from "@/plugins/router";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
	// baseURL: process.env.baseURL || process.env.apiUrl || ""
	// timeout: 60 * 1000, // Timeout
	// withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
	function(config) {
		// Do something before request is sent
		return config;
	},
	function(error) {
		// Do something with request error
		return Promise.reject(error);
	}
);

// Add a response interceptor
_axios.interceptors.response.use(
	function(response) {
		// Do something with response data
		return response;
	},
	function(error) {
		// Do something with response error
		// console.log('code = ', error.response.status);
		// console.log('name = ', error.name);
		// console.log('message = ', error.message);

		// not authenticated? send us back to our logon window...
		if (error.response.status == 401) {
			// console.log("Redirecting to logon");
			router.push({ name: "Logon" });
		}

		return Promise.reject(error);
	}
);

// eslint-disable-next-line
Plugin.install = function(Vue, options) {
	Vue.axios = _axios;
	window.axios = _axios;
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return _axios;
			}
		},
		$axios: {
			get() {
				return _axios;
			}
		}
	});
};

Vue.use(Plugin);

export default Plugin;
